import { render, staticRenderFns } from "./CourseTypes.vue?vue&type=template&id=0b5f5451&"
import script from "./CourseTypes.vue?vue&type=script&lang=js&"
export * from "./CourseTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports